var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { ManageDepartmentsClientService } from "../../../../services/manage/manage-departments-and-roles.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { BindingEngine, computedFrom } from "aurelia-binding";
import { bindable } from "aurelia-templating";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { DataType, SourceType, ItemSource } from "../../../../models/queries/queries.models";
import { Guid } from "../../../../utilities/guid";
import { I18N } from 'aurelia-i18n';
import { LookupValueRequest } from "../../../../models/lookups/lookup.models";
import { CacheClient } from "../../../../services/basics/client-caching.service";
import { NotifyPropertyChangedBase, Reflection } from "../../../../utilities/reflection";
import { GenesisRouterConstants } from "../../../../configuration/router.constants";
import { PermissionEntity } from "../../../../models/manage/permissions.models";
import { Router } from "aurelia-router";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { GenesisLookups } from "../../../../constants/lookups/lookup.constants";
import { CloneUtility } from "../../../../utilities/clone";
import { UserRoleAndClaimsHelper } from "../../../../helpers/user-role-and-claims.helper";
import { UserClientService } from "../../../../services/authentication/user-client.service";
var DepartmentsAndRoles = /** @class */ (function (_super) {
    __extends(DepartmentsAndRoles, _super);
    function DepartmentsAndRoles(lookupService, managedepartmentsService, notificationService, cacheService, router, dialogClient, engine, userClientService, i18N) {
        var _this = _super.call(this) || this;
        _this.lookupService = lookupService;
        _this.managedepartmentsService = managedepartmentsService;
        _this.notificationService = notificationService;
        _this.cacheService = cacheService;
        _this.router = router;
        _this.dialogClient = dialogClient;
        _this.engine = engine;
        _this.userClientService = userClientService;
        _this.i18N = i18N;
        _this._selectedDepartmentId = null;
        _this._departments = [];
        _this.isAnd = true;
        _this.page = 0;
        _this.pages = 1;
        _this.recordsPerPage = 10;
        var request = new LookupValueRequest();
        request.lookupValueQuery = GenesisLookups.branches;
        _this.lookupService.getLookup(request).then(function (x) { return _this.branches = x.values; });
        return _this;
    }
    DepartmentsAndRoles.prototype.goToPermissions = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManagePermissions, {
            type: PermissionEntity.Department,
            id: this.departmentInEdit.departmentId,
            name: this.departmentInEdit.name
        });
    };
    DepartmentsAndRoles.prototype.goToValidations = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManageValidations, {
            type: PermissionEntity.Department,
            id: this.departmentInEdit.departmentId,
            name: this.departmentInEdit.name
        });
    };
    DepartmentsAndRoles.prototype.edit = function () {
        this.isEditCreate = true;
        this.setDepartment(this.departmentInEdit);
    };
    Object.defineProperty(DepartmentsAndRoles.prototype, "onlyOneSelected", {
        get: function () {
            if (this._departments && this.departmentInEdit) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DepartmentsAndRoles.prototype, "anyIsSelected", {
        get: function () {
            if (this._departments && this.departmentInEdit) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    DepartmentsAndRoles.prototype.showDelete = function () {
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModal, this);
    };
    Object.defineProperty(DepartmentsAndRoles.prototype, "activeDepartments", {
        get: function () {
            var source = Enumerable.from(this._departments).where(function (x) { return x.isActive; }).toArray();
            return { source: source, sourceType: SourceType.Collection, columns: this.getColumns() };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DepartmentsAndRoles.prototype, "openedDepartment", {
        get: function () {
            return Enumerable.from(this._departments).firstOrDefault(function (x) { return x.isOpen; });
        },
        enumerable: false,
        configurable: true
    });
    DepartmentsAndRoles.prototype.getColumns = function () {
        return [{
                sortOrder: 1,
                columnOrder: 1,
                name: "name",
                dataType: DataType.Default,
                title: this.i18N.tr('department-name-text')
            }, {
                sortOrder: 2,
                columnOrder: 2,
                name: "scope",
                dataType: DataType.Default,
                title: this.i18N.tr('scope-text')
            },
            {
                sortOrder: 3,
                columnOrder: 3,
                name: "importanceLevel",
                dataType: DataType.Number,
                title: this.i18N.tr('importance-text')
            },
            {
                sortOrder: 3,
                columnOrder: 3,
                name: "scope",
                dataType: DataType.Default,
                title: this.i18N.tr("scope-text")
            },
            {
                sortOrder: 4,
                columnOrder: 4,
                name: "parentDepartment",
                dataType: DataType.Default,
                valueConverter: function (value, item) {
                    return item.parentDepartment == null ? null : item.parentDepartment.name;
                },
                title: this.i18N.tr("parent")
            }
        ];
    };
    Object.defineProperty(DepartmentsAndRoles.prototype, "selectedDepartmentId", {
        get: function () {
            return this._selectedDepartmentId;
        },
        set: function (value) {
            var departmnet = this._departments.filter(function (x) { return x.departmentId == value; })[0];
            this.setDepartment(departmnet);
            this._selectedDepartmentId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DepartmentsAndRoles.prototype, "inactiveDepartments", {
        get: function () {
            var source = Enumerable.from(this._departments).where(function (x) { return !x.isActive; }).toArray();
            return { source: source, sourceType: SourceType.Collection, columns: this.getColumns() };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DepartmentsAndRoles.prototype, "hasPervious", {
        get: function () {
            return this.page > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DepartmentsAndRoles.prototype, "hasNext", {
        get: function () {
            return this.page < this.pages - 1;
        },
        enumerable: false,
        configurable: true
    });
    DepartmentsAndRoles.prototype.canAccessPermissions = function () {
        return UserRoleAndClaimsHelper.HasAccessPermissionsPagePermission(this.userClientService.currentUser.allowedClaims);
    };
    DepartmentsAndRoles.prototype.branchIdChanged = function (x, y) {
        this.isEditCreate = false;
        this.departmentInEdit = null;
        if (!this.branchId) {
            this.pages = 1;
            this._departments = [];
            return;
        }
        this.getAllDepartments(null);
    };
    DepartmentsAndRoles.prototype.setDepartment = function (department) {
        if (department) {
            department.roles = department.roles.filter(function (x) { return x.roleId > 0; });
        }
        this.departmentInEdit = department;
        this.originalDepartmentInEdit = CloneUtility.clone(this.departmentInEdit);
        if (this.departmentInEditUow) {
            this.departmentInEditUow.dispose();
        }
        if (this.departmentInEdit) {
            this.departmentInEditUow = UnitOfWorkObserver.getTrackingInstance(this.engine, this.departmentInEdit);
        }
    };
    DepartmentsAndRoles.prototype.getEmptyDepartment = function () {
        return {
            departmentId: 0,
            managerId: null,
            name: "",
            isActive: false,
            isSelected: false,
            isDefault: false,
            importanceLevel: 0,
            sequenceNumber: 0,
            guid: Guid.generateGuid(),
            permissions: [],
            roles: [],
            branchId: 0,
            scope: ""
        };
    };
    DepartmentsAndRoles.prototype.newDepartment = function () {
        this.setDepartment(this.getEmptyDepartment());
        this.isEditCreate = true;
        this.departmentInEdit.isActive = true;
        this.departmentInEdit.importanceLevel = 1;
        this.departmentInEdit.branchId = this.branchId;
    };
    DepartmentsAndRoles.prototype.save = function () {
        var _this = this;
        if (!this.departmentInEditUow.hasChanges()) {
            return;
        }
        var id = this.departmentInEdit.departmentId;
        this.managedepartmentsService.save({
            changes: this.departmentInEditUow.getChanges(),
            id: id
        })
            .then(function (x) {
            if (x.validationResult && x.validationResult.hasError && x.validationResult.errors[0].messageCode == 1) {
                _this.departmentInEdit = CloneUtility.clone(_this.originalDepartmentInEdit);
                if (_this.departmentInEditUow) {
                    _this.departmentInEditUow.dispose();
                }
                if (_this.departmentInEdit) {
                    _this.departmentInEditUow = UnitOfWorkObserver.getTrackingInstance(_this.engine, _this.departmentInEdit);
                }
                _this.notificationService.show(_this.i18N.tr("error-text"), _this.i18N.tr("one-manager"), NotificationType.Error);
                return;
            }
            _this.departmentInEdit = null;
            _this.page = 0;
            _this.isEditCreate = false;
            _this.notificationService.show(_this.i18N.tr('successfully-saved-text'), _this.i18N.tr('department-has-been-successfully-saved-text'), NotificationType.Success);
            _this.cacheService.removeKeyContains("roles");
            _this.cacheService.removeKeyContains("departments");
            _this.search(id);
        })
            .catch(function (x) {
            _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('department-cannot-be-saved-text'), NotificationType.Error);
        });
    };
    DepartmentsAndRoles.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.managedepartmentsService.deleteDepartment({
                departmentIds: [_this.departmentInEdit.departmentId]
            }).then(function (x) {
                _this.dialogClient.hide();
                _this.notificationService.show(_this.i18N.tr('successfully-deleted-text'), _this.i18N.tr('department-has-been-successfully-deleted-text'), NotificationType.Success);
                _this.search(null);
                resolve();
            }).catch(function (x) {
                _this.notificationService.show(_this.i18N.tr('warning') + "!", _this.i18N.tr('department-cannot-be-deleted-in-use-text'), NotificationType.Warning);
                reject();
            });
        });
    };
    DepartmentsAndRoles.prototype.search = function (selectDepartmentId) {
        this.departmentInEdit = null;
        this.page = 0;
        this.isEditCreate = false;
        this.getAllDepartments(selectDepartmentId);
    };
    DepartmentsAndRoles.prototype.next = function () {
        this.page = this.page + 1;
        this.getAllDepartments(null);
        this.isEditCreate = false;
    };
    DepartmentsAndRoles.prototype.pervious = function () {
        this.page = this.page - 1;
        this.getAllDepartments(null);
        this.isEditCreate = false;
    };
    DepartmentsAndRoles.prototype.cancel = function () {
        this.isEditCreate = false;
    };
    DepartmentsAndRoles.prototype.getAllDepartments = function (selectDepartmentId) {
        var _this = this;
        this.managedepartmentsService.getAllDepartments({
            branchId: this.branchId,
            searchText: this.searchText,
            isAnd: this.isAnd,
            page: this.page,
            recordsPerPage: this.recordsPerPage
        }).then(function (x) {
            _this.pages = x.pages ? x.pages : 1;
            _this._departments = x.departments;
            setTimeout(function () {
                _this.selectedDepartmentId = selectDepartmentId;
            });
        });
    };
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], DepartmentsAndRoles.prototype, "branchId", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._departments; }), Reflection.getPropertyPath(function (x) { return x.changes.activeDepartments; })),
        __metadata("design:type", ItemSource),
        __metadata("design:paramtypes", [])
    ], DepartmentsAndRoles.prototype, "activeDepartments", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._selectedDepartmentId; })),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DepartmentsAndRoles.prototype, "selectedDepartmentId", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._departments; }), Reflection.getPropertyPath(function (x) { return x.changes.inactiveDepartments; })),
        __metadata("design:type", ItemSource),
        __metadata("design:paramtypes", [])
    ], DepartmentsAndRoles.prototype, "inactiveDepartments", null);
    DepartmentsAndRoles = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [LookupClientService,
            ManageDepartmentsClientService,
            NotificationClientService,
            CacheClient,
            Router,
            DialogClientService,
            BindingEngine,
            UserClientService,
            I18N])
    ], DepartmentsAndRoles);
    return DepartmentsAndRoles;
}(NotifyPropertyChangedBase));
export { DepartmentsAndRoles };
